const buildLatLongFilterReduxObject = (
  mapBounds,
  groupByKeys,
  filters = []
) => {
  if (!mapBounds || mapBounds.length !== 2) return filters; // Validate map bounds

  const [minLng, minLat] = mapBounds[0]; // Southwest corner
  const [maxLng, maxLat] = mapBounds[1]; // Northeast corner

  // Convert filters into a Map for quick lookup
  console.log(filters);

  const queryFiltersMap = new Map(
    filters.map((filter) => [
      filter.coordinateType || filter.columnName,
      { ...filter },
    ])
  );
  console.log(queryFiltersMap);

  groupByKeys.forEach((groupItem) => {
    if (
      groupItem.coordinateType === "latitude" ||
      groupItem.coordinateType === "longitude"
    ) {
      const isLatitude = groupItem.coordinateType === "latitude";
      const minValue = isLatitude ? minLat : minLng;
      const maxValue = isLatitude ? maxLat : maxLng;

      if (queryFiltersMap.has(groupItem.coordinateType)) {
        queryFiltersMap.set(groupItem.coordinateType, {
          ...queryFiltersMap.get(groupItem.coordinateType),
          selectedOperator: "BETWEEN",
          minValue,
          maxValue,
        });
      } else {
        queryFiltersMap.set(groupItem.coordinateType, {
          ...groupItem,
          selectedOperator: "BETWEEN",
          minValue,
          maxValue,
        });
      }
    }
  });

  const queryFilters = Array.from(queryFiltersMap.values());

  console.log("Final Filters Array:", queryFilters);

  return queryFilters.length > 0 ? queryFilters : null;
};

const deriveLatLongColumnName = (groupByKeys) => {
  const latColumnName = groupByKeys.find(
    (item) => item.coordinateType === "latitude"
  )?.columnName;
  const longColumnName = groupByKeys.find(
    (item) => item.coordinateType === "longitude"
  )?.columnName;
  return { latColumnName, longColumnName };
};

export { buildLatLongFilterReduxObject, deriveLatLongColumnName };
